import styled, { css } from 'styled-components'

import { _2XL_Light, _S_Medium, _S_Normal, _XL_Light, mainColors } from '../../styles'

const StyledCard = styled.div`
  border-radius: 8px;
  color: ${mainColors.neutralExtremelyDark};
  background-color: ${mainColors.neutralExtraLight};
  border: 1px solid ${mainColors.neutralMedium};
`

export const Card = styled(StyledCard)`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
  padding: 16px;
`

export const Total = styled.div`
  text-align: right;
  color: ${mainColors.black};
  ${_XL_Light};
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`

export const ValuesRow = styled.div`
  display: flex;
  gap: 12px;
`

export const Title = styled.div`
  display: flex;
  ${_S_Normal};
  color: ${mainColors.neutralExtremelyDark};
`

export const CardContent = styled.div<{ $horizontal?: boolean }>`
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 4px;
  ${props =>
    props.$horizontal &&
    css`
      flex-direction: row;
      justify-content: space-between;
    `};
  ${Total} {
    justify-self: start;
    ${_2XL_Light};
    color: ${mainColors.black};
  }
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${mainColors.neutralMedium};
  border-radius: 50px;
  padding: 8px;
`

export const Caption = styled.div`
  display: inline-flex;
  min-height: 20px;
  line-height: 20px;
  color: ${mainColors.neutralExtremelyDark};
  ${_S_Medium};
`
